import styled from "styled-components";
import { ReactComponent as Send } from "../../../assets/img/icons/building.svg";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as Keys } from "../../../assets/img/icons/keys.svg";
import { ReactComponent as Robort } from "../../../assets/img/icons/robot.svg";
import { ReactComponent as People } from "../../../assets/img/icons/people.svg";
import Setting from "../../../assets/img/icons/Setting.svg";
import ShareMenuPopup from "../../Common/Components/ShareMenuPopup";

interface IListCardProps {
  title?: string;
  imgUrlOne?: string;
  imgUrlTwo?: string;
  imgUrlThree?: string;
  list?: boolean;
  settings?: boolean;
  people?: boolean;
  audience?: number;
  send?: number;
  Keys?: number;
  classname?: string;
}

const ListCardTwo: React.FC<IListCardProps> = (props) => {
  return (
    <Wrapper className="list-card-sm-non">
      <div className={`pills-wrapper ${props.classname === undefined ? "" : props.classname}`}>
        <div className="pills">
          {props.settings && (
            <span>
              <img src={Setting} alt="setting" />
              Smart List
            </span>
          )}
          {props.list && (
            <span className="list-icon">
              <Robort />
            </span>
          )}
        </div>
        <div className="pills-heading">Tech Founders</div>
        <div className="details">
          <div className="actions d-flex justify-content-between">
            <ul>
              <li>
                <a>
                  <Audience />
                  <span data-id="qa-total-listcardtwo">{props.audience}</span>
                </a>
              </li>
              <li>
                <a>
                  <Send />
                  <span>{props.send}</span>
                </a>
              </li>
              <li>
                <a>
                  <Keys />
                  <span>{props.Keys}</span>
                </a>
              </li>
            </ul>
            <ul>
              <li className="card-popover">
                <ShareMenuPopup data={props}>
                  <a>
                    <Elipsis />
                  </a>
                </ShareMenuPopup>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="wrapper-preview">
        <div className="preview">
          <div className="left-part">
            <div
              className="preview-1"
              style={{
                backgroundImage: `url(${props.imgUrlOne})`,
              }}
            ></div>
          </div>
          <div className="right-part">
            <div
              className="preview-2"
              style={{
                backgroundImage: `url(${props.imgUrlTwo})`,
              }}
            ></div>
            <div
              className="preview-3"
              style={{
                backgroundImage: `url(${props.imgUrlThree})`,
              }}
            ></div>
          </div>
        </div>
        <div className="preview">
          <div className="right-part f-left">
            <div
              className="preview-2"
              style={{
                backgroundImage: `url(
              ${props.imgUrlTwo}
            )`,
              }}
            ></div>
            <div
              className="preview-3"
              style={{
                backgroundImage: `url(
              ${props.imgUrlThree}
            )`,
              }}
            ></div>
          </div>
          <div className="left-part">
            <div
              className="preview-1"
              style={{
                backgroundImage: `url(
              ${props.imgUrlOne}
            )`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ListCardTwo;

ListCardTwo.defaultProps = {
  imgUrlOne: "https://www.fudzilla.com/media/k2/items/cache/129285d38a9f0d67e7a81e2f4e0004ca_L.jpg",
  imgUrlTwo: "https://www.fudzilla.com/media/k2/items/cache/129285d38a9f0d67e7a81e2f4e0004ca_L.jpg",
  imgUrlThree: "https://techcrunch.com/wp-content/uploads/2019/11/spacex_1.jpg",
  title: "List name here can be 2 lines",
  settings: true,
  list: true,
  people: true,
  audience: 450,
  send: 450,
  Keys: 450,
};

const Wrapper = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  margin-bottom: 50px;
  height: calc(100% - 50px);
  position: relative;
  &.disabled {
    pointer-events: none !important;
    background-color: rgba(225, 225, 225, 0.7) !important;
    cursor: no-drop;
    opacity: 0.6;
  }
  &.list-card-sm {
    height: 280px;
    width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 220px;
    }
    .details {
      display: flex;
      flex-direction: column;
    }
    .name {
      margin-bottom: 10px !important;
    }
    .actions {
      padding: 0px 10px;
      > {
        ul {
          li {
            margin-right: 20px;
          }
        }
      }
    }
    .card-popover {
      margin-right: 0px !important;
    }
  }
  .pills-wrapper {
    position: absolute;
    padding: 18px 18px 10px 18px;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .pills-heading {
    font-family: 'Roboto Slab', serif;
    font-size: 36px;
    color: #ffffff;
    line-height: 35px;
    font-weight: 900;
  }
  .f-left {
    float: left;
  }
  .details {
    width: 100%;
    .actions {
      ul {
        list-style: none;
        margin: 0 -10px;
        padding: 0;
        li {
          float: left;
          display: inline-block;
          padding: 0;
          a {
            padding: 0 5px;
            text-align: center;
            display: block;
            @media all and (max-width: 1300px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding: 0 3px;
            }
            svg {
              width: 18px;
              max-height: 12px;
              path {
                fill: #fff;
              }
              g {
                opacity: 1;
              }
            }
            span {
              color: #fff;
              font-size: 10px;
              font-family: "helveticaneuebold";
              font-weight: 700;
              display: block;
              text-align: center;
            }
          }
          &.card-popover {
            float: right;
            padding-top: 6px;
            a {
              svg {
                width: 5px;
                max-height: none;
                @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                  width: 3px;
                }
                ellipse {
                  fill: #fff;
                }
                g {
                  path {
                    fill: #fff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .pills {
    span {
      padding: 0 3px;
      float: left;
      font-family: 'Roboto Slab', serif;
      font-size: 18px;
      color: #fff;
      font-weight: 600;
      text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
      &.list-icon {
        margin-top: -5px;
      }
    }
  }
  .preview {
    position: relative;
    height: 139px;
    .not-blur {
      filter: none !important;
    }
    .preview-1 {
      width: 70%;
      height: 139px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      filter: blur(8px);
      -webkit-filter: blur(8px);
    }
    .right-part {
      width: 30%;
      display: flex;
      flex-direction: column;
      .preview-2 {
        width: 100%;
        height: 69.5px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        float: left;
        filter: blur(8px);
        -webkit-filter: blur(8px);
      }
      .preview-3 {
        width: 100%;
        height: 69.5px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        float: left;
        filter: blur(8px);
        -webkit-filter: blur(8px);
      }
    }
  }
`;
